import PredefinedDataAutosuggestInputBase, {
  PredefinedDataAutosuggestInputProps,
} from 'components/inputs/predefined-data-autosuggest-input/PredefinedDataAutosuggestInputBase';
import PredefinedDataAutosuggestInputByTypeName from 'components/inputs/predefined-data-autosuggest-input/PredefinedDataAutosuggestInputByTypeName';

export type { PredefinedDataAutosuggestInputProps };

type PredefinedDataAutosuggestInputComponent = ((props: PredefinedDataAutosuggestInputProps) => React.JSX.Element) & {
  ByTypeName: typeof PredefinedDataAutosuggestInputByTypeName;
};

const PredefinedDataAutosuggestInput = Object.assign(PredefinedDataAutosuggestInputBase, {
  ByTypeName: PredefinedDataAutosuggestInputByTypeName,
}) as PredefinedDataAutosuggestInputComponent;

export default PredefinedDataAutosuggestInput;
